module.exports = [{
      plugin: require('/codebuild/output/src2343875867/src/gildform-gatsby/node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-53326JWR68"],"pluginConfig":{"head":true}},
    },{
      plugin: require('/codebuild/output/src2343875867/src/gildform-gatsby/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
